module.exports = __webpack_public_path__ + "media/images/weather/101_night-186a1618237a476d5d1a0ca45f231623.png";